const sidebar = document.querySelector('.sidebar');
const menuBtn = document.querySelectorAll('.menu-btn');
const menuBtnHeader = document.querySelector('.menu-btn-header');
const menuBtnFooter = document.querySelector('.menu-btn-footer');
const menuHref = document.querySelectorAll('.footer__list a[href*="#"]');

if (menuBtnHeader) {
    menuBtnHeader.addEventListener('click', function () {
        menuBtn.forEach(menuBtn =>
            menuBtn.classList.add('open')
        );
        sidebar.classList.add('sidebar--active');
        document.body.style.overflow = 'hidden';
    });
}
if (menuBtnFooter) {
    menuBtnFooter.addEventListener('click', function () {
        menuBtn.forEach(menuBtn =>
            menuBtn.classList.remove('open')
        );
        sidebar.classList.remove('sidebar--active');
        document.body.style.overflow = 'initial';
    });
}
if (menuHref) {
    menuHref.forEach(menuHref =>
        menuHref.addEventListener('click', function () {
            menuBtn.forEach(menuBtn =>
                menuBtn.classList.remove('open')
            );
            sidebar.classList.remove('sidebar--active');
            document.body.style.overflow = 'initial';
        })
    );
}
